import BlogCard from "./BlogCard";
import { blogs } from "./Blog.data";


export default function BlogList() {
  return (
    <section className="relative overflow-hidden rounded-b-lg bg-[#F2F4F7] ">
      {/* Decorative background */}

      <div className="relative z-10 mx-auto max-w-6xl px-6 py-10">
        {/* Page Header */}
        <div className="mx-auto max-w-3xl text-center">

          <p className="indent-16 sm:indent-0 mt-4 text-gray-600 text-left">
            Insights, updates, and expert thinking on technology, development,
            and digital transformation.
          </p>
        </div>

        {/* Blog List – single column rows */}
        <div className="mt-16 space-y-8 max-w-4xl mx-auto">
          {blogs.map((blog) => (
            <BlogCard key={blog.slug} {...blog} />
          ))}
        </div>
      </div>
    </section>
  );
}
